import React from "react";
import moment from "moment";

const statusColorMap = {
  "Validated by requestor":   "rp-status-resubmitted",
  "Approved by line manager": "rp-status-approved",
  "Rejected by line manager": "rp-status-rejected",
  "Approved by finance":      "rp-status-approved",
  "Rejected by finance":      "rp-status-rejected",
  "Completed":                "rp-status-approved",
  "Cancelled":                "rp-status-rejected",
};

export const getStatusBadge = (status) => {
  if (!status) return null;
  const cls = statusColorMap[status] || "rp-status-default";
  return <span className={`rp-status ${cls}`}>{status}</span>;
};

const RequestCard = ({ account, href, onClick }) => (
  <a
    className="hy-card"
    href={href}
    onClick={(e) => { if (e.button === 0 && !e.ctrlKey && !e.metaKey) { e.preventDefault(); onClick && onClick(e); } }}
  >
    <div className="hy-card__header">
      <span className="hy-card__id">{account.id}</span>
      <div>{getStatusBadge(account.status)}</div>
    </div>
    <div className="hy-card__body">
      <div className="hy-card__row">
        <span className="hy-card__label">Account Name</span>
        <span className="hy-card__value">{account.accountName || account.newAccountName || "-"}</span>
      </div>
      <div className="hy-card__row">
        <span className="hy-card__label">Vendor Name</span>
        <span className="hy-card__value">{account.name || "-"}</span>
      </div>
      <div className="hy-card__two-col">
        <div className="hy-card__row">
          <span className="hy-card__label">Requestor</span>
          <span className="hy-card__value">{account.requestedByName || "-"}</span>
        </div>
      </div>
      <div className="hy-card__two-col">
        <div className="hy-card__row">
          <span className="hy-card__label">Line Manager</span>
          <span className="hy-card__value">{account.lineManagerToNotify || "-"}</span>
        </div>
        <div className="hy-card__row">
          <span className="hy-card__label">Finance Approver</span>
          <span className="hy-card__value">{account.financeApproverToNotify || "-"}</span>
        </div>
      </div>
      {account.formSubmittedDate && (
        <div className="hy-card__row">
          <span className="hy-card__label">Submitted</span>
          <span className="hy-card__value">
            {moment(account.formSubmittedDate).format("DD-MM-YYYY HH:mm")}
          </span>
        </div>
      )}
    </div>
</a>
);

export default RequestCard;
